export default __webpack_public_path__ + "static/media/1374.cef88bec.png";